import { Flex, rem, Skeleton } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getPersonTaxInformation } from '@dealstack/frontend/app/services/Person.service.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { InvestorDetailsCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/InvestorDetailsCard/InvestorDetailsCard.tsx';
import { TaxRecordItem } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/TaxRecordsCard/TaxRecordItem.tsx';
import { DetailsCardEmptyState } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/DetailsCardEmptyState.tsx';

interface Props {
	personId: string | undefined;
}

export const TaxRecordsCard = ({ personId }: Props) => {
	const tMipManage = useTranslationMipManage();

	const taxRecordsQuery = useQuery({
		queryKey: [API_PATHS.PERSON_PERSONID_TAX_GET, personId],
		queryFn: () => getPersonTaxInformation(personId ?? ''),
		enabled: !!personId,
	});

	const taxRecords = taxRecordsQuery.data ?? [];

	if (taxRecordsQuery.isPending) {
		return <Skeleton height={rem(204)} radius="0.5rem" />;
	}

	return (
		<InvestorDetailsCard
			title={tMipManage('investors.details.tax_card.title')}
			count={taxRecords.length}
			action={{ kind: 'expand', defaultExpanded: !!taxRecords.length }}
			dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_TAX_CARD}
		>
			{taxRecords.length > 0 ? (
				<Flex direction="column" gap="0.25rem">
					{taxRecords.map((taxRecord) => (
						<TaxRecordItem key={taxRecord.id} taxRecord={taxRecord} />
					))}
				</Flex>
			) : (
				<DetailsCardEmptyState message={tMipManage('investors.details.tax_card.empty')} />
			)}
		</InvestorDetailsCard>
	);
};
